import axios from "axios";
import URLHelper from "../helpers/URLHelper";

const LogBookServices = {
  getModules: async (patient) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/activity-and-plan?patient=${URLHelper.encodeQueryParamValue(patient)}&configured=true`
    );

    return response;
  },
  getTrainings: async (patient, date) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/training/mas-trainer/training-calendar?patient=${URLHelper.encodeQueryParamValue(patient)}&status=finish&date_from=${date}`
    );
    return response;
  },
  getPhysicalActivity: async (patient, date) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/physical-activity?patient=${URLHelper.encodeQueryParamValue(patient)}&date_from=${date}`
    );
    return response;
  },
  getBreathing: async (patient, date) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/training/breathing-experience/breathing-cycle-calendar?status=finish&date_from=${date}&patient=${URLHelper.encodeQueryParamValue(patient)}`
    );
    return response;
  },
  getNotepad: async (patient, date_from) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL +
        `/eira/notepad?date_from=${date_from}&patient=${URLHelper.encodeQueryParamValue(patient)}`
    );
    return response;
  },
};

export default LogBookServices;
